import * as XLSX from 'xlsx';

/**
 * Excel Utility for Special Prayers / Prayer Closet
 * Generates templates and parses uploaded Excel files for bulk or day-wise prayer creation.
 */

// Generate and trigger download for full Special Prayer Bulk Import Template
export const downloadSpecialPrayerTemplate = () => {
  const wb = XLSX.utils.book_new();

  // Sheet 1: Special Prayers (Main Details)
  const prayersData = [
    {
      "Title*": "21 Days Fasting and Prayer",
      "Category*": "General",
      "Description": "21 days focused prayer closet for spiritual revival and church unity.",
      "Plan Type* (fixed/floating/open)": "fixed",
      "From Date* (YYYY-MM-DD)": "2026-10-01",
      "To Date* (YYYY-MM-DD)": "2026-10-21",
      "Number of Days": 21,
      "From Time* (HH:MM)": "06:00",
      "To Time* (HH:MM)": "23:00",
      "Slot Duration* (mins: 10/15/30/60)": 30,
      "Prayer Type (Group/Personal)": "Group",
      "Frequency (Daily/Weekly)": "Daily"
    },
    {
      "Title*": "Season of Advent",
      "Category*": "Seasonal",
      "Description": "A four-week season of joyful expectation and spiritual preparation.",
      "Plan Type* (fixed/floating/open)": "fixed",
      "From Date* (YYYY-MM-DD)": "2026-12-01",
      "To Date* (YYYY-MM-DD)": "2026-12-25",
      "Number of Days": 25,
      "From Time* (HH:MM)": "05:00",
      "To Time* (HH:MM)": "22:00",
      "Slot Duration* (mins: 10/15/30/60)": 15,
      "Prayer Type (Group/Personal)": "Personal",
      "Frequency (Daily/Weekly)": "Daily"
    }
  ];

  const wsPrayers = XLSX.utils.json_to_sheet(prayersData);

  // Column widths for Prayers sheet
  wsPrayers['!cols'] = [
    { wch: 30 }, // Title
    { wch: 18 }, // Category
    { wch: 45 }, // Description
    { wch: 20 }, // Plan Type
    { wch: 16 }, // From Date
    { wch: 16 }, // To Date
    { wch: 15 }, // Number of Days
    { wch: 14 }, // From Time
    { wch: 14 }, // To Time
    { wch: 18 }, // Slot Duration
    { wch: 18 }, // Prayer Type
    { wch: 16 }  // Frequency
  ];

  // Sheet 2: Day-wise Prayer Points
  const pointsData = [
    {
      "Prayer Title* (Must match Sheet 1)": "21 Days Fasting and Prayer",
      "Day Number*": 1,
      "Day Theme / Title": "Day 1: Consecration & Humility",
      "Day Description": "Dedicate this first day to repenting and surrendering to God's will.",
      "Point Title*": "Humility and Repentance",
      "Point Description (English)*": "Pray for personal cleansing and a humble spirit before the Lord.",
      "Telugu Title": "వినయం మరియు పశ్చాత్తాపం",
      "Telugu Description": "ప్రభువు సన్నిధిలో శుద్ధీకరణ కోసం ప్రార్థించండి.",
      "Tamil Title": "",
      "Tamil Description": "",
      "Hindi Title": "",
      "Hindi Description": ""
    },
    {
      "Prayer Title* (Must match Sheet 1)": "21 Days Fasting and Prayer",
      "Day Number*": 1,
      "Day Theme / Title": "Day 1: Consecration & Humility",
      "Day Description": "Dedicate this first day to repenting and surrendering to God's will.",
      "Point Title*": "Family Salvation",
      "Point Description (English)*": "Pray for unsaved family members to encounter the love of Christ.",
      "Telugu Title": "",
      "Telugu Description": "",
      "Tamil Title": "",
      "Tamil Description": "",
      "Hindi Title": "",
      "Hindi Description": ""
    },
    {
      "Prayer Title* (Must match Sheet 1)": "21 Days Fasting and Prayer",
      "Day Number*": 2,
      "Day Theme / Title": "Day 2: Revival in Families",
      "Day Description": "Seeking God's transformation in our homes and relationships.",
      "Point Title*": "Restoration of Peace",
      "Point Description (English)*": "Pray that peace and divine love rule over every Christian home.",
      "Telugu Title": "",
      "Telugu Description": "",
      "Tamil Title": "",
      "Tamil Description": "",
      "Hindi Title": "",
      "Hindi Description": ""
    }
  ];

  const wsPoints = XLSX.utils.json_to_sheet(pointsData);
  wsPoints['!cols'] = [
    { wch: 32 }, // Prayer Title
    { wch: 12 }, // Day Number
    { wch: 28 }, // Day Theme
    { wch: 45 }, // Day Description
    { wch: 28 }, // Point Title
    { wch: 50 }, // Point Description
    { wch: 25 }, // Telugu Title
    { wch: 35 }, // Telugu Description
    { wch: 25 }, // Tamil Title
    { wch: 35 }, // Tamil Description
    { wch: 25 }, // Hindi Title
    { wch: 35 }  // Hindi Description
  ];

  // Sheet 3: Guidelines & Instructions
  const instructions = [
    { "Instructions": "1. Fill out 'Special Prayers' sheet first. Each row defines a prayer closet session." },
    { "Instructions": "2. In 'Prayer Points' sheet, ensure 'Prayer Title' matches the title from the first sheet exactly." },
    { "Instructions": "3. 'Plan Type': Use 'fixed' (with From Date & To Date), 'floating', or 'open'." },
    { "Instructions": "4. 'Slot Duration': Supported values are 10, 15, 30, or 60 minutes." },
    { "Instructions": "5. 'Day Number' starts from 1 up to the total number of days." },
    { "Instructions": "6. Telugu, Tamil, and Hindi fields are optional. English fields marked with (*) are required." },
    { "Instructions": "7. Save this file as .xlsx and upload it using the 'Import from Excel' button on the Admin Portal." }
  ];
  const wsInstructions = XLSX.utils.json_to_sheet(instructions);
  wsInstructions['!cols'] = [{ wch: 100 }];

  XLSX.utils.book_append_sheet(wb, prayersData.length ? wsPrayers : null, "Special Prayers");
  XLSX.utils.book_append_sheet(wb, wsPoints, "Prayer Points");
  XLSX.utils.book_append_sheet(wb, wsInstructions, "Instructions");

  XLSX.writeFile(wb, "Special_Prayers_Template.xlsx");
};

// Generate and trigger download for Day-wise Prayer Points Template only (used inside AddSpecialPrayer.js)
export const downloadDayPointsTemplate = () => {
  const wb = XLSX.utils.book_new();

  const pointsData = [
    {
      "Day Number*": 1,
      "Day Theme / Title": "Day 1: Consecration & Humility",
      "Day Description": "Dedicate this first day to repenting and surrendering to God's will.",
      "Point Title*": "Humility and Repentance",
      "Point Description (English)*": "Pray for personal cleansing and a humble spirit before the Lord.",
      "Telugu Title": "వినయం మరియు పశ్చాత్తాపం",
      "Telugu Description": "ప్రభువు సన్నిధిలో శుద్ధీకరణ కోసం ప్రార్థించండి.",
      "Tamil Title": "",
      "Tamil Description": "",
      "Hindi Title": "",
      "Hindi Description": ""
    },
    {
      "Day Number*": 1,
      "Day Theme / Title": "Day 1: Consecration & Humility",
      "Day Description": "Dedicate this first day to repenting and surrendering to God's will.",
      "Point Title*": "Family Protection",
      "Point Description (English)*": "Pray for God's hedge of protection over our loved ones.",
      "Telugu Title": "",
      "Telugu Description": "",
      "Tamil Title": "",
      "Tamil Description": "",
      "Hindi Title": "",
      "Hindi Description": ""
    },
    {
      "Day Number*": 2,
      "Day Theme / Title": "Day 2: Revival in Church",
      "Day Description": "Praying for spiritual awakening among believers.",
      "Point Title*": "Spiritual Hunger",
      "Point Description (English)*": "Pray for believers to desire deeper intimacy with God through the Word.",
      "Telugu Title": "",
      "Telugu Description": "",
      "Tamil Title": "",
      "Tamil Description": "",
      "Hindi Title": "",
      "Hindi Description": ""
    }
  ];

  const ws = XLSX.utils.json_to_sheet(pointsData);
  ws['!cols'] = [
    { wch: 12 },
    { wch: 28 },
    { wch: 45 },
    { wch: 28 },
    { wch: 50 },
    { wch: 25 },
    { wch: 35 },
    { wch: 25 },
    { wch: 35 },
    { wch: 25 },
    { wch: 35 }
  ];

  XLSX.utils.book_append_sheet(wb, ws, "Day Points");
  XLSX.writeFile(wb, "Prayer_Points_Template.xlsx");
};

// Helper: Format Date from Excel to YYYY-MM-DD
const formatDateValue = (val) => {
  if (!val) return '';
  if (val instanceof Date) {
    const pad = (n) => String(n).padStart(2, '0');
    return `${val.getFullYear()}-${pad(val.getMonth() + 1)}-${pad(val.getDate())}`;
  }
  if (typeof val === 'number') {
    // Excel serial number
    const dateObj = new Date(Math.round((val - 25569) * 86400 * 1000));
    const pad = (n) => String(n).padStart(2, '0');
    return `${dateObj.getFullYear()}-${pad(dateObj.getMonth() + 1)}-${pad(dateObj.getDate())}`;
  }
  const str = String(val).trim();
  // Check if DD-MM-YYYY or DD/MM/YYYY
  const parts = str.split(/[-/]/);
  if (parts.length === 3) {
    if (parts[0].length === 4) {
      // YYYY-MM-DD
      return `${parts[0]}-${parts[1].padStart(2, '0')}-${parts[2].padStart(2, '0')}`;
    } else if (parts[2].length === 4) {
      // DD-MM-YYYY
      return `${parts[2]}-${parts[1].padStart(2, '0')}-${parts[0].padStart(2, '0')}`;
    }
  }
  return str;
};

// Helper: Format Time from Excel to HH:MM
const formatTimeValue = (val) => {
  if (!val) return '06:00';
  if (typeof val === 'number') {
    // Excel fractional day (e.g. 0.25 = 06:00)
    const totalMinutes = Math.round(val * 24 * 60);
    const hours = Math.floor(totalMinutes / 60);
    const mins = totalMinutes % 60;
    return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
  }
  const str = String(val).trim();
  if (str.includes(':')) {
    const [h, m] = str.split(':');
    return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
  }
  return str;
};

/**
 * Parse an Excel file for Day Points only (used in AddSpecialPrayer.js)
 * Returns dayWiseData object formatted for AddSpecialPrayer component state.
 */
export const parseDayPointsExcel = async (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const rows = XLSX.utils.sheet_to_json(sheet);

        if (!rows || rows.length === 0) {
          throw new Error("No data found in the uploaded file.");
        }

        const dayWiseData = {};

        rows.forEach((row) => {
          // Flexible key lookup
          const dayNum = Number(row['Day Number*'] || row['Day Number'] || row['Day'] || 1);
          const dayTitle = row['Day Theme / Title'] || row['Day Title'] || row['Theme'] || '';
          const dayDesc = row['Day Description'] || row['Description'] || '';
          const pointTitle = row['Point Title*'] || row['Point Title'] || row['Title'] || '';
          const pointDesc = row['Point Description (English)*'] || row['Point Description'] || row['Prayer Point'] || '';

          if (!dayWiseData[dayNum]) {
            dayWiseData[dayNum] = {
              title: dayTitle,
              description: dayDesc,
              te_title: row['Telugu Title'] || '',
              te_description: row['Telugu Description'] || '',
              ta_title: row['Tamil Title'] || '',
              ta_description: row['Tamil Description'] || '',
              ml_title: '',
              ml_description: '',
              hi_title: row['Hindi Title'] || '',
              hi_description: row['Hindi Description'] || '',
              currentLang: 'en',
              prayerPoints: []
            };
          } else {
            // Update day title/desc if provided later
            if (dayTitle && !dayWiseData[dayNum].title) dayWiseData[dayNum].title = dayTitle;
            if (dayDesc && !dayWiseData[dayNum].description) dayWiseData[dayNum].description = dayDesc;
          }

          if (pointTitle || pointDesc) {
            dayWiseData[dayNum].prayerPoints.push({
              title: pointTitle || `Point ${dayWiseData[dayNum].prayerPoints.length + 1}`,
              description: pointDesc || pointTitle,
              te_title: row['Telugu Title'] || '',
              te_description: row['Telugu Description'] || '',
              ta_title: row['Tamil Title'] || '',
              ta_description: row['Tamil Description'] || '',
              ml_title: '',
              ml_description: '',
              hi_title: row['Hindi Title'] || '',
              hi_description: row['Hindi Description'] || '',
              currentLang: 'en'
            });
          }
        });

        resolve(dayWiseData);
      } catch (err) {
        reject(err);
      }
    };
    reader.onerror = (err) => reject(err);
    reader.readAsArrayBuffer(file);
  });
};

/**
 * Parse a full Special Prayers Excel file with multiple prayers & day points
 * Returns an array of validated prayer objects ready for creation.
 */
export const parseFullPrayersExcel = async (file, categories = []) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });

        // Find sheets
        const prayersSheetName = workbook.SheetNames.find(n => n.toLowerCase().includes('special') || n.toLowerCase().includes('prayer')) || workbook.SheetNames[0];
        const pointsSheetName = workbook.SheetNames.find(n => n.toLowerCase().includes('point')) || workbook.SheetNames[1];

        const prayersSheet = workbook.Sheets[prayersSheetName];
        const prayersRows = XLSX.utils.sheet_to_json(prayersSheet);

        if (!prayersRows || prayersRows.length === 0) {
          throw new Error("No prayers found in the 'Special Prayers' sheet.");
        }

        let pointsRows = [];
        if (pointsSheetName && workbook.Sheets[pointsSheetName]) {
          pointsRows = XLSX.utils.sheet_to_json(workbook.Sheets[pointsSheetName]);
        }

        // Group points by Prayer Title
        const pointsByPrayer = {};
        pointsRows.forEach((row) => {
          const prayerTitle = (row['Prayer Title* (Must match Sheet 1)'] || row['Prayer Title'] || row['Title'] || '').trim().toLowerCase();
          if (!prayerTitle) return;

          if (!pointsByPrayer[prayerTitle]) {
            pointsByPrayer[prayerTitle] = [];
          }
          pointsByPrayer[prayerTitle].push(row);
        });

        // Resolve category ID by name
        const findCategoryId = (catName) => {
          if (!catName) return categories[0]?.id || 1;
          const match = categories.find(c =>
            c.name?.toLowerCase() === String(catName).trim().toLowerCase() ||
            String(c.id) === String(catName).trim()
          );
          return match ? match.id : (categories[0]?.id || 1);
        };

        // Construct full prayer payloads
        const parsedPrayers = prayersRows.map((row, idx) => {
          const title = (row['Title*'] || row['Title'] || `Special Prayer ${idx + 1}`).trim();
          const categoryName = row['Category*'] || row['Category'] || '';
          const categoryId = findCategoryId(categoryName);
          const description = row['Description'] || '';
          const rawPlan = (row['Plan Type* (fixed/floating/open)'] || row['Plan Type'] || 'fixed').toLowerCase().trim();
          const prayerPlan = ['fixed', 'floating', 'open'].includes(rawPlan) ? rawPlan : 'fixed';

          const fromDate = formatDateValue(row['From Date* (YYYY-MM-DD)'] || row['From Date']);
          const toDate = formatDateValue(row['To Date* (YYYY-MM-DD)'] || row['To Date']);
          let numDays = Number(row['Number of Days'] || 0);

          if (!numDays && fromDate && toDate) {
            const f = new Date(fromDate);
            const t = new Date(toDate);
            if (t >= f) {
              numDays = Math.ceil((t - f) / (1000 * 60 * 60 * 24)) + 1;
            }
          }
          if (!numDays) numDays = 1;

          const fromTime = formatTimeValue(row['From Time* (HH:MM)'] || row['From Time']);
          const toTime = formatTimeValue(row['To Time* (HH:MM)'] || row['To Time']);
          const rawDuration = Number(row['Slot Duration* (mins: 10/15/30/60)'] || row['Slot Duration'] || 30);
          const slotDuration = [10, 15, 30, 60].includes(rawDuration) ? rawDuration : 30;

          const prayerType = (row['Prayer Type (Group/Personal)'] || row['Prayer Type'] || 'Group').trim();
          const prayerFrequency = (row['Frequency (Daily/Weekly)'] || row['Frequency'] || 'Daily').trim();

          // Build dayWiseData for this prayer
          const matchingPoints = pointsByPrayer[title.toLowerCase()] || [];
          const dayWiseData = {};

          // Initialize all days
          for (let d = 1; d <= numDays; d++) {
            dayWiseData[d] = {
              title: `Day ${d}`,
              description: `Prayer points for day ${d}`,
              currentLang: 'en',
              prayerPoints: []
            };
          }

          // Populate with matching points from Sheet 2
          matchingPoints.forEach((pRow) => {
            const dayNum = Number(pRow['Day Number*'] || pRow['Day Number'] || 1);
            if (dayNum >= 1 && dayNum <= numDays) {
              if (pRow['Day Theme / Title']) dayWiseData[dayNum].title = pRow['Day Theme / Title'];
              if (pRow['Day Description']) dayWiseData[dayNum].description = pRow['Day Description'];

              const pTitle = pRow['Point Title*'] || pRow['Point Title'] || '';
              const pDesc = pRow['Point Description (English)*'] || pRow['Point Description'] || '';

              if (pTitle || pDesc) {
                dayWiseData[dayNum].prayerPoints.push({
                  title: pTitle || `Point ${dayWiseData[dayNum].prayerPoints.length + 1}`,
                  description: pDesc || pTitle,
                  te_title: pRow['Telugu Title'] || '',
                  te_description: pRow['Telugu Description'] || '',
                  ta_title: pRow['Tamil Title'] || '',
                  ta_description: pRow['Tamil Description'] || '',
                  ml_title: '',
                  ml_description: '',
                  hi_title: pRow['Hindi Title'] || '',
                  hi_description: pRow['Hindi Description'] || '',
                  currentLang: 'en'
                });
              }
            }
          });

          // Ensure every day has at least 1 default point if none was supplied
          for (let d = 1; d <= numDays; d++) {
            if (!dayWiseData[d].prayerPoints || dayWiseData[d].prayerPoints.length === 0) {
              dayWiseData[d].prayerPoints.push({
                title: dayWiseData[d].title || `Day ${d} Prayer`,
                description: dayWiseData[d].description || `Lord, we bring Day ${d} into your hands.`,
                currentLang: 'en'
              });
            }
          }

          return {
            title,
            category: categoryId,
            categoryName: categoryName || 'Default',
            description,
            prayerPlan,
            fromDate,
            toDate,
            numberOfDays: numDays,
            fromTime,
            toTime,
            slotDuration,
            prayerType,
            prayerFrequency,
            dayWiseData,
            pointsCount: Object.values(dayWiseData).reduce((sum, d) => sum + (d.prayerPoints?.length || 0), 0)
          };
        });

        resolve(parsedPrayers);
      } catch (err) {
        reject(err);
      }
    };
    reader.onerror = (err) => reject(err);
    reader.readAsArrayBuffer(file);
  });
};
